import { FC, ReactNode } from 'react';
import { Button, Tooltip } from 'antd';

import styles from './styles.module.css';

type ActionButtonType = 'default' | 'primary';

interface Props {
    children: ReactNode;
    onClick: () => void;
    disabled?: boolean;
    tooltip?: string;
    type?: ActionButtonType;
    htmlType?: 'button' | 'submit';
    loading?: boolean;
}

export const ActionButton: FC<Props> = ({
    children,
    onClick,
    disabled,
    tooltip,
    type = 'default',
    htmlType = 'button',
    loading,
}) => {
    const button = (
        <Button
            onClick={onClick}
            disabled={disabled}
            htmlType={htmlType}
            loading={loading}
            className={type === 'primary' ? styles.primaryButton : styles.actionButton}
        >
            {children}
        </Button>
    );

    if (disabled && tooltip) {
        return (
            <Tooltip title={tooltip}>
                {button}
            </Tooltip>
        );
    }

    return button;
};
